import httpClient from '../httpClient';


const getCinema =  (page,pagesSize) => httpClient.get(`/Cinemas?page=${1}&pageSize=${1000}`).then(
  (data) => data
)
  .catch((e)=>{
    //
  })
const setCinema =  (params) => httpClient.post('/Cinemas', params,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })
const putCinema = (params,id) => httpClient.put(`/Cinemas/${id}`, params,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })
const deleteCinema= (id) => httpClient.delete(`/Cinemas/${id}`,{ headers: { Authorization: `Bearer ${localStorage.getItem('lotusToken')}` } })
export {
  getCinema,
  setCinema,
  putCinema,
  deleteCinema,
  // getUser,
  // createUser
}
